import {Setting} from "./Setting";

export const cultureSetting: Setting = {
    key: "Culture",
    title: "Культура",
    description: `Культура это совокупность традиций, обычаев, искусства, религии, языка и других аспектов, формирующих идентичность обществ и отдельных персонажей. Культура влияет на взаимодействие между персонажами, сюжетные линии и атмосферу мира.`,
    components:[
        {
            title: "Традиции и обычаи",
            subComponents: [
                {
                    title: "Семейные обряды",
                    description: `Свадьбы, похороны, ритуалы взросления. Праздники и фестивали.`,
                    examples: ["Свадьба, где собираются родственники и друзья."]
                },
                {
                    title: "Праздники и фестивали",
                    description: `Сезонные (урожай, солнцестояние). Религиозные (почитание богов). Исторические (победы в войнах, основания городов).`,
                    examples: ["Праздник урожая, где собираются все жители города.", "Праздник основания города, с парадами и фейерверками."]
        },
                {
                    title: "Повседневные обычаи",
                    description: `Приветствия, манеры, обряды в еде.`,
                    examples: ["Традиция встречать гостей с хлебом и солью."]
                }
            ]
        },
        {
            title: "Искусство и творчество",
            subComponents: [
                {
                    title: "Музыка",
                    description: `Народные мелодии, эпические баллады. Использование магических инструментов.`,
                    examples: ["Песни о героях и легендах."]
                },
                {
                    title: "Литература",
                    description: `Эпические поэмы, священные тексты, легенды.`,
                    examples: ["Книга сказаний, хранящая историю народа."]
                },
                {
                    title: "Изобразительное искусство",
                    description: `Картины, статуи, росписи. Уникальные стили (например, магическая каллиграфия).`,
                    examples: ["Статуя богини, установленная в храме."]
                },
                {
                    title: "Архитектура",
                    description: `Храмы, дворцы, общественные здания. Уникальные черты в зависимости от региона (дома на деревьях, подземные города).`,
                    examples: ["Дворец короля, построенный в стиле готики."]
                }]
        },
        {
            title: "Религия и мифология",
            subComponents: [
                {
                    title: "Боги и духи",
                    description: `Пантеоны, монотеистические системы. Поклонение природным или магическим силам.`,
                    examples: ["Храм, где совершаются ритуалы в честь богов."]
                },
                {
                    title: "Ритуалы",
                    description: `Жертвоприношения, молитвы, паломничества.`,
                    examples: ["Ритуал посева, проводимый в начале весны."]
                },
                {
                    title: "Мифы",
                    description: `Легенды о сотворении мира, героях, катастрофах.`,
                    examples: ["Легенда о герое, победившем дракона."]
                }]
        },
        {
            title: "Язык",
            subComponents: [
                {
                    title: "Диалекты",
                    description: `Региональные различия, влияние других культур.`,
                    examples: ["Диалект фермеров, использующий специфические термины."]
                },
                {
                    title: "Письменность",
                    description: `Уникальные алфавиты, магические руны.`,
                    examples: ["Руны, используемые для создания заклинаний."]
                },
                {
                    title: "Жесты",
                    description: `Культурные отличия в невербальной коммуникации.`,
                    examples: ["Жест приветствия, используемый во дворце."]
                }]
        },
        {
            title: "Еда и напитки",
            subComponents: [
                {
                    title: "Национальные блюда",
                    description: `Уникальные рецепты, зависящие от региона. Магически приготовленные блюда.`,
                    examples: ["Пирог с магическими травами."]
                },
                {
                    title: "Напитки",
                    description: `Ритуальные (священные настои). Алкогольные (уникальные эльфийские вина, гномий эль).`,
                    examples: ["Эльфийское вино, дарующее долголетие."]
                }]
        },{
            title: "Одежда и внешний вид",
            subComponents: [
                {
                    title: "Национальные костюмы",
                    description: `Традиционная одежда для ритуалов или повседневной жизни.`,
                    examples: ["Одежда шамана, украшенная амулетами."]
                },
                {
                    title: "Украшения",
                    description: `Символы статуса, магические артефакты.`,
                    examples: ["Кольцо с гербом королевской семьи."]
                },
                {
                    title: "Прически",
                    description: `Характерные стили для разных классов или рас.`,
                    examples: ["Прическа, символизирующая звание воина."]
                }]
        }
    ],
    prompt: {
        component: {
            list: 'Опиши культуру мира включая основные компоненты',
            single: 'Сгенерируй компонент культуры для мира. Опиши ключевые аспекты, традиции и влияние на общество',
            extend: 'Дополни компонент культуры подробностями и разбей на абзацы. Как он влияет на мир и персонажей. Опиши только указанный компонент культуры'
        },
        element: {
            list: 'Сгенерируй элементы культуры для компонента',
            single: 'Сгенерируй элемент культуры для компонента. Опиши ключевые аспекты, традиции и влияние на общество',
            extend: 'Дополни элемент культуры подробностями и разбей на абзацы. Как он влияет на мир и персонажей. Опиши только указанный элемент культуры'
        },
        lore: {
            list: "Создай элементы лора на основе этого элемента культуры. Его историю, мифы, влияние на мир и персонажей",
            single: "Создай элементы лора на основе этого элемента культуры. Опиши что-то одно, например: историю, мифы, влияние на мир и персонажей",
            extend: "Дополни описание элемента лора культуры и разбей на абзацы."
        }
    }
}